/**
 * English project covers — authored via the `/pack` toile process (plan
 * `thinking/plans/2026_08_31_toile_pack_wiring.md` Track B), wave `toile_project_pages`. Narcis file-split
 * shape (Track A): one module per pack, `registry.ts` assembles them into `livePacks`.
 */
import {tagline, chips, type ToilePack} from './data'

export const englishProjectCoversPack: ToilePack = {
    slug: 'english-project-covers',
    category: 'classroom',
    name: 'English project covers',
    tagline: tagline('pieces', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: {w: 832, h: 1216},
    readings: [
        {key: 'books', label: 'Books', subject: 'a cover with stacked books and a pencil around "ENGLISH PROJECT"'},
        {key: 'quill', label: 'Quill', subject: 'a cover with a quill and ink pot'},
        {key: 'alphabet', label: 'Alphabet', subject: 'a cover with scattered letters'},
    ],
    styles: [
        {key: 'sketch', label: 'Sketch pens', style: 'outlined in black fineliner and filled in with bright sketch pens in flat even colour, neat hand-drawn lines with a slight wobble', palette: 'warm reds, blues, yellows and greens', framing: 'centred on a white A4 sheet seen straight on with an even clean margin all round'},
        {key: 'pencil', label: 'Colour pencils', style: 'drawn in sharp colour pencils with soft layered shading and visible pencil strokes, a gentle hand-coloured finish', palette: 'soft pencil tones of brown, rose and sky blue', framing: 'filling a white A4 sheet seen straight on, a narrow pencil-ruled margin line inside the edge of the page'},
        {key: 'duo', label: 'Two-colour pen', style: 'drawn in black gel pen with one accent colour of highlighter, clean ink lines, minimal and tidy', palette: 'black ink with orange highlighter only', framing: 'on a cream notebook page seen straight on with a generous margin'},
    ],
    directions: ['poetry', 'Shakespeare', 'grammar'],
    directionHint: 'try: poetry',
    seo: {
        title: 'English project covers: books, quill, alphabet',
        metaDescription: 'Nine hand-drawn English project covers: books, quill and alphabet designs, in sketch pens, colour pencils or gel pen.',
        h1: 'English project covers: books, quill, alphabet',
        tagline: 'Nine covers: books, a quill and an alphabet, each in three pen styles.',
        intro: 'Front pages for an English project file, drawn by hand with pens and colours. The books cover has stacked books and a pencil around the words ENGLISH PROJECT. The quill cover has a quill and an ink pot. The alphabet cover has scattered letters. Each comes in three pen styles. Type a twist, such as poetry, Shakespeare or grammar, and the same three subjects can take it.',
        useCases: [
            'an English project for school',
            'a poetry or literature file',
            'a grammar or writing practice file',
        ],
        faq: [
            {q: 'What is on the quill cover?', a: 'A quill and an ink pot.'},
            {q: 'Which cover suits a poetry file?', a: 'Any of them. Type poetry as a twist and the same three covers can take it, as a request rather than a promised result.'},
            {q: 'What are the three styles?', a: 'Sketch pens use bright flat colour inside black fineliner outlines. Colour pencils give soft layered shading in pastel tones. Two-colour pen is black gel ink with one highlighter colour.'},
        ],
    },
}
